export default __webpack_public_path__ + "static/media/graph-type-3-cropped.6b8cf7b6.png";